"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribers = exports.bus = exports.WithTrekkerContext = exports.useTrekker = exports.useOnTrekkerMount = exports.TrekkerHoc = exports.Trek = exports.TC = exports.TrekkerProvider = exports.trekkerFactory = void 0;
const tslib_1 = require("tslib");
const factory_1 = require("./factory");
const ifmatch_1 = require("./subscribers/ifmatch");
const fbq_1 = require("./subscribers/fbq");
const gtag_1 = require("./subscribers/gtag");
const ga_1 = require("./subscribers/ga");
var factory_2 = require("./factory");
Object.defineProperty(exports, "trekkerFactory", { enumerable: true, get: function () { return factory_2.trekkerFactory; } });
(0, tslib_1.__exportStar)(require("./types"), exports);
_a = (0, factory_1.trekkerFactory)(() => ({
    href: location.href
})), exports.TrekkerProvider = _a.TrekkerProvider, exports.TC = _a.TC, exports.Trek = _a.Trek, exports.TrekkerHoc = _a.TrekkerHoc, exports.useOnTrekkerMount = _a.useOnTrekkerMount, exports.useTrekker = _a.useTrekker, exports.WithTrekkerContext = _a.WithTrekkerContext, exports.bus = _a.bus;
exports.subscribers = {
    ifMatch: ifmatch_1.ifMatch,
    gtag: gtag_1.gtagSubscriber,
    ga: ga_1.gaSubscriber,
    fbq: fbq_1.fbqSubscriber,
};
//# sourceMappingURL=index.js.map